<template>
    <modal-dialog v-if='is_open' @close='is_open=false'>
        <template #header>
            <span>{{$t('addTermHeader')}}</span>
        </template>
        <template #body>
            <div class='term-content'>
                <div>{{$t('searchTerm')}}</div>
                <div class='skills'>
                    <inline-skill-selector ref='skill' :initial-skills='[]' @selected="onSkillsChanged" :allow-subject-selection="false" :multi='false' />
                </div>

                <div v-if='!video_found'>
                    <label style='width:100%'>
                        {{$t('video_url')}}
                        <input type='url' @blur="checkVideoLink"  placeholder="https://youtube/...."  v-model='video_url' style='width:100%'>
                    </label>
                </div>
                <div v-if='video_found'>
                    <iframe width="120" height="80" :src="video_url" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <button class='btn btn-warning' @click='video_url="";video_found=false'>Remove</button>
                </div>

                <div class='description'>
                    {{$t('description')}}
                    <medium v-model='description' />
                    <!-- <textarea v-model='description' style='width:100%;min-height:200px'></textarea> -->
                </div>
            </div>
        </template>
        <template #footer>
            <button class="btn btn-secondary" @click="cancel">{{$t('Cancel')}}</button>
            <button class="btn btn-primary" @click="add">{{$t('Add')}}</button>
        </template>
    </modal-dialog>
</template>

<script>
import InlineSkillSelector from '@root/components/inline-skill-selector.vue';
import ModalDialog from '@root/components/ModalDialog.vue';
import i18n from '@root/components/i18n';
import Helper from '../components/helper';
import Api from '../components/api';
import Medium from '@root/medium/medium.vue';

export default {
    name: "add-term-dialog",
    props: [],
    mixins: [i18n],
    data: function() {
        return {
            is_open: false,
            video_url: '',
            description: '',
            callback: null,
            video_found: false,
            skill: null,
        }
    },
    computed: {        
    },
    components: {
        InlineSkillSelector, ModalDialog, Medium,
    },
    mounted: function() {    
    },       
    methods: {       
        open: function(entryId, callback) {
            this.callback = callback;
            this.entryId = entryId;
            this.video_url = '';
            this.description = '';
            this.video_found = false;
            this.is_open = true;            
            this.$nextTick(()=>{
                this.$refs.skill.focus();
            });
        },
        add: async function() {
            if (this.skill == null) {
                // todo: show error
                return;
            }
            const response = await Api.course.addTerm(this.entryId, this.skill.id, this.video_url, this.description);
            const termId = response.data.addTerm;
            this.callback({
                id: termId,
                name: this.skill.name,
                definition: this.description,
                video_url: this.video_url,
                area: this.skill.area,
                material: null,
            });
            this.is_open = false;
        },
        cancel: function() {
            this.is_open = false;
        },
        onSkillsChanged: async function(items) {
            this.skill = items.length > 0 ? items[0] : null;
            if (this.skill?.id) {
                this.description = await Api.getSkillDescription(this.skill.id);
                console.log("New description", this.description);
            }
        },
        checkVideoLink: function() {
            var result = Helper.canonizeVideoUrl(this.video_url);
            if (result.ok) {
                console.log("video_url", result.url);
                this.video_url = result.url;
                this.video_found = true;
            } else {
                console.log("video url error", result);
                this.video_found = false;
            }
        },
    }
}
</script>

<i18n>
{
    en: {
        "addTermHeader": "Add Term",
        "video_url": "Link to Youtube",
        "description": "Definition",
        "searchTerm": "Search the term or create new one",
    },
    ru: {        
        "addTermHeader": "Добавить термин",
        "video_url": "Ссылка на видео Youtube",
        "description": "Определение",
        "searchTerm": "Попробуйте найти термин в базе или создайте новый",
    }
}
</i18n>


<style lang="scss" scoped>
 

</style>